export default "__VITE_ASSET__CE8vb_Y___"